import { EmotionJSX } from "@emotion/react/types/jsx-namespace"
import { Box } from "@mui/material"
import ActiveRowItem from "./ActiveRowItem"
import InactiveRowItem from "./InactiveRowItem"
import * as styles from "./RowItem.styles"

type Props = {
    name: string
    selected: boolean
    expanded: boolean
    onClick: () => void
    inactiveIconComponent: () => EmotionJSX.Element
    activeIconComponent: () => EmotionJSX.Element
}

export default function RowItem(props: Props) {
    return (
        <Box css={styles.rowItem}>
            {props.selected ? (
                <ActiveRowItem
                    {...props}
                    iconComponent={props.activeIconComponent}
                />
            ) : (
                <InactiveRowItem
                    {...props}
                    iconComponent={props.inactiveIconComponent}
                />
            )}
        </Box>
    )
}
